<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetSiteInformation widgetNoTopBorder widget-two-columns-one-gap-fifty-percent" *ngIf="(widgetData$ | async) as widgetData">
  <div class="table-part">
    <table style="height: 100%; table-layout: auto;" aria-hidden="true">
      <thead>
        <tr class="red-line">
          <th scope="col" colspan="8">
            <widget-label [widget]="this" [fieldName]="'labelMarketIncome'" [align]="'left'" [color]="'white'" [bold]="true">
            </widget-label>
          </th>
        </tr>
        <tr class="white-line">
          <th scope="col" colspan="4"> &nbsp;</th>
          <th scope="col"> &nbsp;</th>
          <th scope="col">
            <widget-label [widget]="this" [fieldName]="'labelBaseRent'" [align]="'center'" [bold]="true"></widget-label>
          </th>
          <th scope="col">
            <widget-label [widget]="this" [fieldName]="'labelRecoveries'" [align]="'center'" [bold]="true"></widget-label>
          </th>
          <th scope="col">
            <widget-label [widget]="this" [fieldName]="'labelTotal'" [align]="'center'" [bold]="true"></widget-label>
          </th>
        </tr>
      </thead>
      <tbody class="viewModeTbody">
        <tr class="white-line" *ngFor="let marketIncome of widgetData.marketIncomes; let index=index">
          <td colspan="4">
            <widget-value [align]="'left'">{{marketIncome.name }} </widget-value>
          </td>
          <td>&nbsp; </td>
          <td>
            <widget-value [align]="'center'">
              {{marketIncome.values.baseRent | rdLocalizedNumber:2 | rdFormatNegativeNumbers }}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'">
              {{marketIncome.values.recoveries | rdLocalizedNumber:2 | rdFormatNegativeNumbers }}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'">
              {{marketIncome.values.total | rdLocalizedNumber:2 | rdFormatNegativeNumbers }}
            </widget-value>
          </td>
        </tr>
        <tr class="white-line border-bottom-dark-grey">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelSundryIncome'" [align]="'left'">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td> &nbsp;</td>
          <td> &nbsp; </td>
          <td style="text-align:center;"> - </td>
        </tr>
        <tr class="white-line">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelGrossMarketIncome'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.grossMarketIncome.baseRent | rdLocalizedNumber:2 | rdFormatNegativeNumbers}}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.grossMarketIncome.recoveries | rdLocalizedNumber:2 | rdFormatNegativeNumbers}}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.grossMarketIncome.total | rdLocalizedNumber:2 | rdFormatNegativeNumbers }}
            </widget-value>
          </td>
        </tr>
        <tr class="white-line">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelAdoptedOutgoings'" [align]="'left'">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td> &nbsp; </td>
          <td> &nbsp; </td>
          <td>
            <widget-value [align]="'center'">
              {{widgetData.adoptedOutgoings.total | rdLocalizedNumber:2 | rdFormatNegativeNumbers | rdFormatNegativeNumbers}}
            </widget-value>
          </td>
        </tr>
        <tr class="white-line border-bottom-dark-grey">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelGroundRent'" [align]="'left'">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td> &nbsp;</td>
          <td> &nbsp; </td>
          <td style="text-align:center;"> - </td>
        </tr>
        <tr class="white-line">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelNetMarketIncome'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td> &nbsp; </td>
          <td>&nbsp; </td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.netMarketIncome.total | rdLocalizedNumber:2 | rdFormatNegativeNumbers }}
            </widget-value>
          </td>
        </tr>
        <tr class="white-line border-bottom-dark-grey">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelVacancyFactor'" [align]="'left'">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td> &nbsp;</td>
          <td> &nbsp; </td>
          <td style="text-align:center;"> - </td>
        </tr>
        <tr class="white-line">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelNetIncome'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td> &nbsp; </td>
          <td>&nbsp; </td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.netIncome.total | rdLocalizedNumber:2 | rdFormatNegativeNumbers }}
            </widget-value>
          </td>
        </tr>
        <tr class="white-line">
          <td colspan="4">
            &nbsp;
          </td>
          <td>&nbsp; </td>
          <td> &nbsp;</td>
          <td> &nbsp; </td>
          <td style="text-align:center;"> - </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelMarketCapitalisationRate'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.marketCapitalisationRate.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}%
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.marketCapitalisationRate.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}%
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.marketCapitalisationRate.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}%
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCoreCapitalValue'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'" [bold]="true">
              {{
widgetData.coreCapitalValue.baseRent | rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'" [bold]="true">
              {{
widgetData.coreCapitalValue.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.coreCapitalValue.total | rdLocalizedNumber:2 | rdFormatNegativeNumbers }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCoreCapitalValuePerArea'" [suffix]="' ' + unitOfArea" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.coreCapitalValuePerArea.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.coreCapitalValuePerArea.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.coreCapitalValuePerArea.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>

        <tr class="red-line">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelCapitalValueAdjustments'" [align]="'left'" [color]="'white'" [bold]="true">
            </widget-label>
          </td>
          <td> &nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp; </td>
          <td>&nbsp; </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelPresentValueOfRentalReversions'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.presentValueOfRentalReversions.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.presentValueOfRentalReversions.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.presentValueOfRentalReversions.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCapitalValueofSpecialIncome'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.capitalValueofSpecialIncome.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.capitalValueofSpecialIncome.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.capitalValueofSpecialIncome.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCapitalValueofStabilisationAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;">- </td>
          <td class="light-grey-line" style="text-align:center;">-  </td>
          <td class="white-line" style="text-align:center;">-</td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCapitalValueOfOtherAdjustments'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;">- </td>
          <td class="light-grey-line" style="text-align:center;">-  </td>
          <td class="white-line" style="text-align:center;">-</td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelOutstandingIncentives'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.outstandingIncentives.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.outstandingIncentives.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.outstandingIncentives.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCapitalValueOfAdditionalLand'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;">- </td>
          <td class="light-grey-line" style="text-align:center;">-  </td>
          <td class="white-line" style="text-align:center;">-</td>
        </tr>

        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelDeferredTenancies'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;"></td>
          <td class="light-grey-line" style="text-align:center;"></td>
          <td class="white-line" style="text-align:center;"></td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelLettingUpAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.deferredTenancies.lettingUpAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.deferredTenancies.lettingUpAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.deferredTenancies.lettingUpAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelIncentiveAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.deferredTenancies.incentiveAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.deferredTenancies.incentiveAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.deferredTenancies.incentiveAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelLeasingCostsAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;">- </td>
          <td class="light-grey-line" style="text-align:center;">-  </td>
          <td class="white-line" style="text-align:center;">-</td>
        </tr>

        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelExistingAllowances'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;"></td>
          <td class="light-grey-line" style="text-align:center;"></td>
          <td class="white-line" style="text-align:center;"></td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelLettingUpAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.lettingUpAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.lettingUpAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.lettingUpAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelIncentiveAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.incentiveAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.incentiveAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.incentiveAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelLeasingCostsAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.leasingCostsAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.leasingCostsAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.existingAllowances.leasingCostsAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>

        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelImminentAllowances'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;"></td>
          <td class="light-grey-line" style="text-align:center;"></td>
          <td class="white-line" style="text-align:center;"></td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelLettingUpAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelMonths'" [prefix]="'24'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.lettingUpAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.lettingUpAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.lettingUpAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelIncentiveAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelMonths'" [prefix]="'24'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.incentiveAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.incentiveAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.incentiveAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelLeasingCostsAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelMonths'" [prefix]="'24'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.leasingCostsAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.leasingCostsAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.leasingCostsAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelRefurbishmentAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelMonths'" [prefix]="'24'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.refurbishmentAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.refurbishmentAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.imminentAllowances.refurbishmentAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCapitalExpenditure'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line" style="text-align:center;"></td>
          <td class="light-grey-line" style="text-align:center;"></td>
          <td class="white-line" style="text-align:center;"></td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelBudgetedCapitalExpenditure'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelMonths'" [prefix]="'24'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.budgetedCapitalExpenditure.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.budgetedCapitalExpenditure.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.budgetedCapitalExpenditure.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr class="border-bottom-dark-grey">
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelCapitalSinkingFundsAllowance'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelMonths'" [prefix]="'24'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.capitalSinkingFundsAllowance.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.capitalSinkingFundsAllowance.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.capitalSinkingFundsAllowance.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>



        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelTotalCapitalValueAdjustments'" [align]="'left'" [bold]="true">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.totalCapitalValueAdjustments.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.totalCapitalValueAdjustments.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.totalCapitalValueAdjustments.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr class="dark-grey-line">
          <td colspan="4">
            <widget-label [widget]="this" [fieldName]="'labelCapitalisedValue'" [align]="'left'" [color]="'white'">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td>
            <widget-value [align]="'center'" [color]="'white'">
              {{
widgetData.capitalisedValue.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'" [color]="'white'">
              {{
widgetData.capitalisedValue.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'" [color]="'white'">
              {{
widgetData.capitalisedValue.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr class="dark-grey-line">
          <td colspan="4">
            <widget-label [widget]="this" [color]="'white'" [fieldName]="'labelCapitalisedValuePerArea'" [suffix]="'('+currency+'/'+unitOfArea+')'" [align]="'left'">
            </widget-label>
          </td>
          <td>&nbsp; </td>
          <td>
            <widget-value [align]="'center'" [color]="'white'">
              {{
widgetData.capitalisedValuePerArea.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'" [color]="'white'">
              {{
widgetData.capitalisedValuePerArea.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'" [color]="'white'">
              {{
widgetData.capitalisedValuePerArea.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelRoundedValue'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp; </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.roundedValue.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.roundedValue.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.roundedValue.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="white-line">
            <widget-label [widget]="this" [fieldName]="'labelRoundedValuePerArea'" [suffix]="'('+currency+'/'+unitOfArea+')'" [align]="'left'">
            </widget-label>
          </td>
          <td class="white-line">&nbsp;</td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.roundedValuePerArea.baseRent |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="light-grey-line">
            <widget-value [align]="'center'">
              {{
widgetData.roundedValuePerArea.recoveries |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
          <td class="white-line">
            <widget-value [align]="'center'">
              {{
widgetData.roundedValuePerArea.total |
                            rdLocalizedNumber:2 | rdFormatNegativeNumbers
              }}
            </widget-value>
          </td>
        </tr>
      <tbody class="viewModeTbody">
      </tbody>
    </table>
  </div>
</div>
